import { formatDate } from "../common/BaseUtil"
import { useState, useEffect } from 'react';
import { basePort, headers, setTokenHeader, renderRedirect, getJwtFromCookies, isExpiredJwt, getUsernameJwt } from "../../module_auth/AuthService"
import { CTMY_BASE_POST_URL, REPLY_MESSAGE_NO_AUTH } from './CmtyConstant'
import { CmtyBaseReply } from './CmtyBaseReply'
import { ToastMessage } from "../../component/common/Toast"
import { ModalMessage } from "../../component/common/Modal"
import '../../App.css'
import './Cmty.css'

// 댓글(코멘트):포스팅에 다는 글
export function CmtyBaseComment(props) {

    //대댓글 리스트업
    const [cmtyReplyList, setCmtyReplyList] = useState([]);

    const [hiddenReplyTextField, setHiddenReplyTextField] = useState(true);
    const [hiddenReplyCancelBtn, setHiddenReplyCancelBtn] = useState(true);
    const [hiddenEditDropdown, setHiddenEditDropdown] = useState(true);

    const [redirect, setRedirect] = useState(false);
    const [redirectUrl, setRedirectUrl] = useState("");
    const [accessToken, setAccessToken] = useState("");

    const [textareaDisabled, setTextareaDisabled] = useState(false);
    const [placeHolderMessage, setPlaceHolderMessage] = useState("");
    const [cmtyReply, setCmtyReply] = useState("");

    const [hiddenCommentEditor, setHiddenCommentEditor] = useState(true);
    const [commentEditorContent, setCommentEditorContent] = useState("");

    //modal
    const [showModalLogin, setShowModalLogin] = useState(false);
    const [showModalDelete, setShowModalDelete] = useState(false);

    //toast
    const [showToast, setShowToast] = useState(false);
    const [msgToast, setMsgToast] = useState("");

    useEffect(() => {
        if (getJwtFromCookies() == null || isExpiredJwt(getJwtFromCookies())) {
            //1.login
            setRedirectUrl('/login')
            setTextareaDisabled(true)
            setPlaceHolderMessage(REPLY_MESSAGE_NO_AUTH)
            setHiddenEditDropdown(true)
        } else {
            //1.cmty_post
            setAccessToken(getJwtFromCookies())
            setTextareaDisabled(false)
            setPlaceHolderMessage("")
            if (getUsernameJwt(getJwtFromCookies()) === props.object.username) {
                setHiddenEditDropdown(false)
            } else {
                setHiddenEditDropdown(true)
            }
        }
        loadCmtyReplyList()
        loadCmtyCommentEditorContent()
    }, []);

    function loadCmtyCommentEditorContent() {
        setCommentEditorContent(props.object.content)
    }

    function loadCmtyReplyList() {
        let url = basePort + '/get/cmty/reply/views/' + props.object.id
        fetch(url,
            {
                method: 'GET', headers,
                body: JSON.stringify()
            })
            .then(response => response.json())
            .then(response => {
                setCmtyReplyList(response)
                console.log("setCmtyReplyList: " + response)
            }).catch(error => console.log(error))
    }

    function shwoReplyTextField() {
        if (accessToken) {
            setHiddenReplyTextField(false)
            setHiddenReplyCancelBtn(false)
        } else {
            clickModalLoginBtn()
        }
    }

    function hideReplyTextField() {
        setHiddenReplyTextField(true)
        setHiddenReplyCancelBtn(true)
    }

    function handleTextarea(event) {
        setCmtyReply(event.target.value);
    }

    function clickPostReply(event) {
        if (accessToken) {
            //post comment!
            event.preventDefault();
            setTokenHeader(getJwtFromCookies())
            fetch(basePort + '/reply/cmty',
                {
                    method: 'post', headers,
                    body: JSON.stringify({
                        content: cmtyReply,
                        cmtyPostId: props.object.cmtyPostId,
                        cmtyCommentId: props.object.id,
                        replyMbrId: props.object.mbrId,
                    })
                })
                .then(response => response.json())
                .then(response => {
                    if (response.validRequest) {
                        fadeOutToast(response.validationMessage)
                        setTimeout(function () {
                            window.location.reload();
                        }.bind(this), 3000)
                    } else {
                        fadeOutToast(response.validationMessage)
                    }
                }).catch(function (error) {
                    console.log(error);
                });
        } else {
            clickModalLoginBtn()
        }
    }

    function fadeOutToast(msg) {
        setToastMessage(true, msg)
        setTimeout(function () {
            setToastMessage(false, "")
        }.bind(this), 3000);
    }

    function setToastMessage(show, message) {
        setShowToast(show)
        setMsgToast(message)
    }

    //수정 등록
    function postCommentEdit(event) {
        setTokenHeader(getJwtFromCookies())
        fetch(basePort + '/update/cmty/comment',
            {
                method: 'post', headers,
                body: JSON.stringify({
                    content: commentEditorContent,
                    cmtyCommentId: props.object.id,
                })
            })
            .then(response => response.json())
            .then(response => {
                if (response.validRequest) {
                    fadeOutToast(response.validationMessage)
                    setTimeout(function () {
                        window.location.reload();
                    }.bind(this), 3000)
                } else {
                    fadeOutToast(response.validationMessage)
                }
            }).catch(function (error) {
                console.log(error);
            });
    }

    function clickCommentEdit(event) {
        setHiddenCommentEditor(false)
    }

    function handleCommentEditorContent(event) {
        setCommentEditorContent(event.target.value);
    }

    function cancelCommentEdit(event) {
        setHiddenCommentEditor(true)
    }

    function closeModalLoginBtn() {
        setShowModalLogin(false)
    }

    function submitModalLoginBtn() {
        setShowModalLogin(false)
        setRedirectUrl('/login')
        setRedirect(true)
    }

    function clickModalLoginBtn() {
        setShowModalLogin(true)
    }

    function closeModalDeleteBtn() {
        setShowModalDelete(false)
    }

    function clickModalDeleteBtn() {
        setShowModalDelete(true)
    }

    function submitModalDeleteBtn() {
        setShowModalDelete(false)
        clickCommentDelete()
    }

    //삭제 등록
    function clickCommentDelete(event) {
        setTokenHeader(getJwtFromCookies())
        fetch(basePort + '/delete/cmty/comment',
            {
                method: 'post', headers,
                body: JSON.stringify({
                    cmtyCommentId: props.object.id,
                })
            })
            .then(response => response.json())
            .then(response => {
                if (response.validRequest) {
                    fadeOutToast(response.validationMessage)
                    setTimeout(function () {
                        window.location.reload();
                    }.bind(this), 1000)
                } else {
                    fadeOutToast(response.validationMessage)
                }
            }).catch(function (error) {
                console.log(error);
            });
    }

    return (
        <li class="list-group-item">
            {renderRedirect(redirect, redirectUrl)}
            {/* comment block */}
            <div class="card border-0" key={props.index}>
                <div class="card-body">
                    <p class="card-text" className="comment-reply-nickname">
                        {/* 댓글(코멘트)을 쓴 닉네임 */}
                        {props.object.nickname}
                        <div class="dropdown show" hidden={hiddenEditDropdown} style={{ fontFamily: 'Nanum Gothic' }}>
                            <a class="dropdown-toggle custom-dropdown-toggle" aria-expanded="true" data-bs-toggle="dropdown" style={{ color: "black", fontWeight: 'bold', textDecoration: "none" }} data-bs-display="static">...</a>
                            <div class="dropdown-menu custom-dropdown" data-bs-popper="none">
                                <a class="dropdown-item pulse animated" onClick={clickCommentEdit}>수정</a> {/* 댓글(코멘트) 수정버튼 */}
                                <a class="dropdown-item pulse animated" onClick={clickModalDeleteBtn}>삭제</a> {/* 댓글(코멘트) 삭제버튼 */}
                            </div>
                        </div>
                    </p>
                    {/* 댓글(코멘트) 내용 */}
                    {/* <p class="card-text"><pre>{props.object.content}</pre></p> */}
                    <p class="card-text" style={{
                        color: '#222222',
                        whiteSpace: 'pre-wrap',   // 줄바꿈 보존 + 너비를 넘어가면 자동 줄바꿈
                        wordBreak: 'break-all',   // 긴 단어도 잘리지 않게 처리
                        fontFamily: 'inherit'     // 부모 요소의 글씨체 상속
                    }}>{props.object.content}</p>
                    {/* 댓글(코멘트) 내용에 답글쓰기 */}
                    <p class="card-text">{formatDate(props.object.updateAt)} {/* 댓글 등록날짜 */}
                        <button type="button" class="btn btn-link" style={{ color: "grey", textDecoration: "none" }} onClick={shwoReplyTextField}>답글쓰기</button>
                        {/* 답글쓰기 클릭시 답글취소 활성화 */}
                        <button type="button" class="btn btn-link" style={{ color: "grey", textDecoration: "none" }} onClick={hideReplyTextField} hidden={hiddenReplyCancelBtn}>답글취소</button>
                    </p>
                </div>
            </div>
            {/* comment editor 댓글(코멘트) 수정버튼 클릭후 활성화: 기존내용 수정가능 */}
            <div class="card-body" hidden={hiddenCommentEditor}>
                <textarea class="form-control" aria-label="Message" value={commentEditorContent} onChange={handleCommentEditorContent}></textarea>
                <div class="card-footer text-muted" style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                    <button type="button" class="btn btn-light" style={{ fontSize: "12px", borderRadius: '5px', marginRight: "5px" }} onClick={cancelCommentEdit}>취소</button>
                    <button type="button" class="btn btn-secondary" style={{ fontSize: "12px", borderRadius: '5px' }} onClick={postCommentEdit}>등록</button>
                </div>
            </div>

            {/* reply post editor 답글쓰기 클릭시 에디터 활성화: 답글등록 가능 */}
            <div class="card-body" hidden={hiddenReplyTextField}>
                <div class="input-group mb-3">
                    <textarea class="form-control" aria-label="Message" placeholder={placeHolderMessage} onChange={handleTextarea} disabled={textareaDisabled}></textarea>
                    <button type="button" class="btn btn-secondary" style={{ fontSize: "12px", borderRadius: '0 5px 5px 0' }} onClick={clickPostReply}>답글등록</button>
                </div>
            </div>

            {/* 답글리스트 */}
            <ul class="list-group list-group-flush">
                {cmtyReplyList.map((object, index) => (
                    <CmtyBaseReply object={object} index={index} />
                ))}
            </ul>
            <ToastMessage show={showToast} msg={msgToast} />
            <ModalMessage show={showModalLogin} closeBtn={closeModalLoginBtn}
                submitBtn={submitModalLoginBtn} title={"로그인이 필요합니다."} msg={"로그인 페이지로 안내해 드릴까요?"} />
            <ModalMessage show={showModalDelete} closeBtn={closeModalDeleteBtn}
                submitBtn={submitModalDeleteBtn} title={"삭제 확인"} msg={"정말로 이 항목을 삭제하시겠습니까?"} />
        </li>
    );
}